'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _leftNav = require('material-ui/lib/left-nav');

var _leftNav2 = _interopRequireDefault(_leftNav);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BinaryLeftPannel = function (_Component) {
  _inherits(BinaryLeftPannel, _Component);

  function BinaryLeftPannel(props) {
    _classCallCheck(this, BinaryLeftPannel);

    var _this = _possibleConstructorReturn(this, (BinaryLeftPannel.__proto__ || Object.getPrototypeOf(BinaryLeftPannel)).call(this, props));

    _this.styles = require('./BinaryLeftPannel.scss');
    return _this;
  }

  _createClass(BinaryLeftPannel, [{
    key: 'getNav',
    value: function getNav() {
      var navData = this.props.navData;

      var DATA = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = navData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var navItem = _step.value;

          DATA.push(_react2.default.createElement(
            'div',
            { key: navItem.key ? navItem.key : Math.random(), className: this.styles.binary_left_pannel_nav },
            navItem
          ));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return DATA;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          open = _props.open,
          title = _props.title,
          data = _props.data,
          handleClose = _props.handleClose,
          width = _props.width;

      return _react2.default.createElement(
        _leftNav2.default,
        {
          docked: false,
          width: width ? width : 850,
          open: open,
          openRight: true,
          className: this.styles.binary_left_pannel,
          disableSwipeToOpen: true,
          onRequestChange: function onRequestChange(change) {
            handleClose(change);
          }
        },
        _react2.default.createElement(
          _Grid2.default,
          { className: this.styles.binary_left_pannel_container },
          _react2.default.createElement(
            _Row2.default,
            { className: this.styles.binary_left_pannel_title },
            _react2.default.createElement(
              _Col2.default,
              { xs: 8, md: 8 },
              _react2.default.createElement(
                'h3',
                null,
                title
              )
            ),
            _react2.default.createElement(
              _Col2.default,
              { xs: 4, md: 4, key: 'binary_nav' },
              this.getNav()
            )
          ),
          _react2.default.createElement(
            _Row2.default,
            { className: this.styles.binary_left_pannel_body },
            data
          )
        )
      );
    }
  }]);

  return BinaryLeftPannel;
}(_react.Component);

BinaryLeftPannel.propTypes = {
  open: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  handleClose: _propTypes2.default.func,
  data: _propTypes2.default.node.isRequired,
  navData: _propTypes2.default.array,
  width: _propTypes2.default.number
};
BinaryLeftPannel.defaultProps = {
  open: false,
  title: ''
};
exports.default = BinaryLeftPannel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryLeftPannel/BinaryLeftPannel.js
// module id = 2179
// module chunks = 1